// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderTitle":"c-m_fB"};